import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const TableAlignmentBottom = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path d="M13.5 14a.5.5 0 0 1-.5.5H3a.5.5 0 0 1 0-1h10c.28 0 .5.22.5.5Z" fill={color} />
        <path d="M11.5 8.04 8 11.5m0 0L4.5 8.04M8 11.5v-9" stroke={color} strokeLinecap="round" />
      </svg>
    )
  },
)

export default TableAlignmentBottom
